module.exports = __webpack_public_path__ + "static/media/lazybones-logo.3c18c49f.png";